import React from 'react'
import { connect } from 'react-redux'
import type { Maybe } from '@adc/sdk/types'
import type {
  primitives,
  AuctionBlueprintOnlineReactiveArgs,
  AuctionBlueprintScheduledOnlineReactiveArgs,
} from '@adc/blueprint'
import type { FeatureFlags } from '@adc/ui-adc'
import AuctionStatusNotification from 'common/components/auctionStatusNotification'
import BidAgain from 'common/modules/bidBanner/bidAgain'
import { isPendingFclOnlineDeposit } from 'common/utils/listing'
import { enums } from '@adc/sdk'
import { useListingContext } from '../../context/listing'
import Before from './states/before'
import During from './states/during'
import Scheduled from './states/scheduled'
import Won from './states/won'

export const showTPSOnlineBidBanner = (
  segment: Maybe<AuctionBlueprintScheduledOnlineReactiveArgs['segment']>,
  listing: AuctionBlueprintOnlineReactiveArgs['listing'],
  featureFlags: FeatureFlags = {}
): boolean => {
  const isRegisteredOrPendingDeposit =
    listing?.is_current_user_registered_for_online_auction ||
    isPendingFclOnlineDeposit(listing, featureFlags)

  return Boolean(
    isRegisteredOrPendingDeposit &&
      (segment?.segment_status === enums.OnlineAuctionSegmentStatus.Pending ||
        segment?.__methods__?.isOnlineAuctionActive() ||
        segment?.__methods__?.isMaxBiddingActive() ||
        segment?.current_user_bidding_status ===
          enums.OnlineAuctionSegmentBiddingStatus.Won)
  )
}

// TODO: fill up the rest of this interface, will need to see what <During which props is spread into is using so we can make it explicit and stop the props spreading
interface TpsOnlineBidBannerProps {
  featureFlags: FeatureFlags
  user: primitives.AuctionUser
}

const TPSOnlineBidBanner = (props: TpsOnlineBidBannerProps) => {
  const { featureFlags, user } = props
  const { segment, listing } = useListingContext()
  const renderTpsOnlineBidBanner = () => {
    if (!showTPSOnlineBidBanner(segment, listing, featureFlags)) {
      return null
    }

    if (segment?.__methods__?.isOnlineAuctionActive()) {
      return (
        <>
          <BidAgain />
          <During {...props} />
        </>
      )
    } else if (segment?.__methods__?.isMaxBiddingActive()) {
      return <Before featureFlags={featureFlags} user={user} />
    } else if (
      segment?.segment_status === enums.OnlineAuctionSegmentStatus.Pending
    ) {
      return <Scheduled />
    } else if (
      segment?.current_user_bidding_status ===
      enums.OnlineAuctionSegmentBiddingStatus.Won
    ) {
      return <Won />
    } else return null
  }

  return (
    <>
      <AuctionStatusNotification listing={listing} />
      <>{renderTpsOnlineBidBanner()}</>
    </>
  )
}

const mapStateToProps = (store: any) => ({
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
  featureFlags: store.featureFlags,
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
  user: store.user,
})

export default connect(mapStateToProps)(TPSOnlineBidBanner)
